import { Field, FormTheme } from '@kanda-libs/ks-component-ts';
import type { FunctionComponent } from 'react';
import { NOTE_FIELD_PROPS } from './constants';
import useJobNotes from './useJobNotes';

const JobNotesField: FunctionComponent = function () {
  const notes = useJobNotes();
  return (
    <div className="flex flex-col">
      <div className="flex flex-row flex-wrap mb-3 md:mb-0">
        <span className="text-16-20-em text-neutral-900 mr-1.5 md:mr-3">
          Customer Note
        </span>
        <span className="whitespace-nowrap text-style-h text-neutral-600">
          (Visible the quote to the customer)
        </span>
      </div>
      <FormTheme variant="emphasized">
        <Field.RichTextInput {...NOTE_FIELD_PROPS} initialValue={notes} />
      </FormTheme>
    </div>
  );
};

export default JobNotesField;
